import { IconInfoCircle } from '@tabler/icons-react';
import { useState } from 'react';
import { Offcanvas } from 'react-bootstrap';
import { getApi } from '../../../../api/call.api';
import { urlApi } from '../../../../api/url.api';
import { loadingHide, loadingShow } from '../../../../loadingUi/loading.controller';

const VisitorDetailsSidebar = ({ visitorData }) => {
    const [show, setShow] = useState(false);
    const [details, setDetails] = useState(null);

    const handleClose = () => { setDetails(null); setShow(false) };
    const handleShow = () => setShow(true);

    const getDetails = async () => {
        loadingShow();
        let resp = await getApi(urlApi.getVisitorDetails + visitorData?.visitorId);
        loadingHide();
        handleShow();
        if (resp.responseCode === 200) {
            setDetails(resp.data)
        } else {
            setDetails(null)
        }
    }

    return (
        <>
            <button className='p-1.5 bg-slate-200 hover:bg-gray-100 text-xs rounded-full hover:text-gray-500 hover:cursor-pointer text-gray-700 transition' onClick={getDetails} title='Visitor Details'>
                <IconInfoCircle size={20} />
            </button>

            <Offcanvas show={show} onHide={handleClose} placement='end'>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title as={'h4'}>Visitor Details</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className='flex items-center justify-center gap-2'>
                        <img src={details?.profilePic || "https://img.freepik.com/premium-vector/character-avatar-isolated_729149-194801.jpg"} alt="" className='w-10 h-10 rounded-full' />
                        <div className="flex flex-col gap-1">
                            <p className='text-sm font-semibold'>{details?.name || "Visitor"} | #{visitorData?.chatSessionCount}</p>
                            <p className='text-xs text-gray-500'>{details?.phone || "No Phone"}</p>
                        </div>
                    </div>
                    <hr className='my-2' />

                    <div className='flex flex-col gap-2'>
                        <p className='text-sm font-semibold'>Visitor Details</p>
                        <div className='flex flex-col gap-1'>
                            <p className='text-xs text-gray-500'>Login By: {details?.loginBy || "No Login"}</p>
                            <p className='text-xs text-gray-500'>Online Status:<span className={`${details?.onlineStatus == 1 ? 'text-green-600' : 'text-red-600'}`}> {details?.onlineStatus == 1 ? "Online" : "Offline"}</span></p>
                            <p className='text-xs text-gray-500'>Status: {details?.status == 1 ? "Active" : "Inactive"}</p>
                            <div>
                                <p className='text-xs text-gray-500'>Location: </p>
                                {
                                    Object.entries(details?.geoLocation || {})?.length > 0 ?
                                        <div className='ps-3'>
                                            {Object.entries(details?.geoLocation || {})?.map(([key, value]) => {
                                                return (
                                                    <p key={key} className='text-xs text-gray-500'>{key?.charAt(0)?.toUpperCase() + key?.slice(1)}: {value || "No Data"}</p>
                                                )
                                            })}
                                        </div>
                                        :
                                        <p className='text-xs text-gray-500 ps-3'>No Location Data Available</p>
                                }
                            </div>
                        </div>
                    </div>
                    <hr className='my-2' />

                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}

export default VisitorDetailsSidebar